<template>
	<div>
		<Head :title="form.name" />

		<div class="mb-8 flex max-w-3xl justify-start">
			<Breadcrumbs
				href="/kams"
				:parentLabel="__('Key account managers')"
				:childLabel="form.name"
			/>

			<img v-if="kam.photo" class="ml-4 block h-8 w-8 rounded-full" :src="kam.photo" :alt="kam.name" />
		</div>

		<div class="w-full overflow-hidden rounded-md bg-white shadow">
			<form @submit.prevent="update">
				<div class="-mb-8 -mr-6 flex flex-wrap p-8">
					<TextInput
						v-model="form.name" :error="form.errors.name"
						class="w-full pb-8 pr-6 lg:w-1/2"
						:label="__('Name')"
					/>

					<TextInput
						v-model="form.role" :error="form.errors.role"
						class="w-full pb-8 pr-6 lg:w-1/2"
						:label="__('Role')"
					/>

					<TextInput
						v-model="form.phone"
						class="w-full pb-8 pr-6 lg:w-1/2"
						:error="form.errors.phone"
						:label="__('Phone')"
					/>

					<TextInput
						v-model="form.email"
						class="w-full pb-8 pr-6 lg:w-1/2"
						:error="form.errors.email"
						:label="__('Email')"
					/>

					<FileInput
						v-model="form.photo"
						type="file"
						class="w-full pb-8 pr-6 lg:w-1/2"
						accept="image/*"
						:error="form.errors.photo"
						:label="__('Foto - kvadratisk bild i jpg- eller pngformat')"
					/>
				</div>

				<div class="-mb-8 -mr-6 flex flex-wrap p-8">
					<label class="form-label">Regioner och kategorier</label>
					<AccordionList class="w-full" :open-multiple-items="false">
						<AccordionItem class="mb-2 pl-4 pr-4 rounded border border-gray-100" :id="region.id" v-for="region in regions" :key="region.id">
							<template #summary>{{ region.name }}</template>
							<template #icon>{{!region_categories?.[region.id]?.length ? '' : `${region_categories[region.id].length} kategori(er) valda`}}</template>
							<VueMultiselect
								v-model="region_categories[region.id]"
								class="pb-4"
								:options="categories?.map(c => ({id: c.id, label: c.name})) ?? []"
								:searchable="true"
								:multiple="true"
								:close-on-select="true"
								track-by="id"
								label="label"
								tag-placeholder="Lägg till kategori"
								placeholder="Skriv för att söka och lägga till en kategori"
							/>
						</AccordionItem>
					</AccordionList>
				</div>
				<div class="flex items-center border-t border-gray-100 bg-gray-50 px-8 py-4">
					<button
						v-if="!kam.deleted_at"
						class="text-red-600 hover:underline"
						tabindex="-1"
						type="button"
						@click="destroy"
					>
						{{ __('Delete') }}
					</button>
					<button
						v-if="kam.deleted_at"
						class="hover:underline"
						tabindex="-1"
						type="button"
						@click="restore"
					>
						Återställ
					</button>

					<LoadingButton
						:loading="form.processing"
						class="btn-save ml-auto"
						type="submit"
					>
						{{ __('Update') }}
					</LoadingButton>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
	import { Head } 	  from '@inertiajs/inertia-vue3'
	import Layout 		  from '@/Shared/Layout'
	import TextInput 	  from '@/Shared/TextInput'
	import FileInput 	  from '@/Shared/FileInput'
	import LoadingButton  from '@/Shared/LoadingButton'
	import Breadcrumbs    from '@/Shared/Breadcrumbs'
	import { AccordionList, AccordionItem } from "vue3-rich-accordion";
	import VueMultiselect  from 'vue-multiselect'

	export default {
		components: {
			FileInput,
			Head,
			Breadcrumbs,
			LoadingButton,
			TextInput,
			AccordionList,
			AccordionItem,
			VueMultiselect
		},
		layout: Layout,
		remember: 'form',
		props: {
			kam: Object,
			regions: Array,
			categories: Array,
		},
		data() {
			return {
				form: this.$inertia.form({
					_method: 'put',
					name: this.kam.name,
					role: this.kam.role,
					phone: this.kam.phone,
					email: this.kam.email,
					password: '',
					photo: null,
					region_categories: []
				}),
				// JSONing back and forth prevents replace stage bug from occuring (https://github.com/inertiajs/inertia/issues/775)
				region_categories: JSON.parse(JSON.stringify(this.kam.region_categories))
			}
		},
		methods: {
			update() {
				// JSONing back and forth prevents replace stage bug from occuring (https://github.com/inertiajs/inertia/issues/775)
				this.form.region_categories = JSON.parse(JSON.stringify(this.region_categories))
				this.form.post(`/kams/${ this.kam.id }`, {
					onSuccess: () => this.form.reset('password', 'photo'),
				})
			},
			destroy() {
				if (confirm('Är du säker på att du vill ta bort denna person?')) {
					this.$inertia.delete(`/kams/${ this.kam.id }`)
				}
			},
			restore() {
				if (confirm('Är du säker på att du vill återställa denna person?')) {
					this.$inertia.put(`/kams/${ this.kam.id }/restore`)
				}
			}
		}
	}
</script>
<style src="vue-multiselect/dist/vue-multiselect.css"></style>
<style>
.accordion-item__summary {
	display: flex;
	justify-content: space-between;
	line-height: 50px;
	cursor: pointer;
}

.accordion-item__summary-title,
.accordion-item__summary-icon {
	display: flex;
}
</style>